import { createApiDescription } from "../../helperFunctions";

export const composeMessageInfo = {
    sendMessage: createApiDescription(
        "SSE APIs to send message.",
        [
            "Send Message API supports Callback mechanism, callbackUri can be configured in the request body with callback-api-key in the request header. Once request is sent from Send Message API, the response will be posted to the configured callback endpoint URL.",
            "Authentication message will be “Access Code” when send a secure message via the API.",
            "If retention period is not set we will take your user default."
        ]
    ),
}